import { Injectable } from '@angular/core';

import { FoodModel, MealModel, NutritionModel } from '../../models/models';
import { ApiProvider } from '../api/api';
import { FoodProvider } from '../food/food';

@Injectable()
export class MealProvider {
  private items: MealModel[] = [];

  constructor(
    private api: ApiProvider,
    private foodProvider: FoodProvider) {
  }

  Add(item: MealModel) {
    this.items.push(item);
  }

  async DeleteFoodItems(ids: number[]) {
    var promises = [];
    for (let id of ids) {
      promises.push(this.DeleteFoodItem(id));
    }
    await Promise.all(promises);
  }

  DeleteFoodItem(id: number) {
    return new Promise((resolve, reject) => {
      this.api.delete(`meal/food/${id}`).subscribe((res) => {
        const data = res.json();
        if (data.success) {
          resolve(true);
        }
        resolve(false);
      });
    });
  }

  Exists(item: MealModel): boolean {

    // TODO: Better checking
    return this.items.find(x => {
      return x._id !== item._id && x.Name === item.Name && x.FoodCount === item.FoodItems.length;
    }) !== undefined;

    // const simpleFoodItems = (foodItems: FoodModel[]) => {
    //   return JSON.stringify(
    //     foodItems.map((x: FoodModel) => { 
    //       return { 
    //         _id: x._id, 
    //         Serving: x.Serving
    //       } as FoodModel
    //     })
    //     .sort((a: FoodModel, b: FoodModel) => {  
    //       if (a._id.toLowerCase() > b._id.toLowerCase()) return 1;
    //       else if (a._id.toLowerCase() < b._id.toLowerCase()) return -1;
    //       else return 0;
    //     })
    //   );
    // };

    // let foodItems = simpleFoodItems(item.FoodItems);

    // return this.items.find((x: MealModel) => {
    //   return (x._id !== item._id 
    //     && x.Name.toLowerCase() === item.Name.toLowerCase() 
    //     && x.FoodItems.length === item.FoodItems.length
    //     && simpleFoodItems(x.FoodItems) === foodItems);
    // }) !== undefined;
  }

  Get(id) {
    return this.items.find(x => x._id === id);
  }

  List() {
    return this.items;
  }

  Load() {
    return new Promise((resolve, reject) => {
      if (this.items.length === 0) {
        this.LoadFromApi().then((data: MealModel[]) => {
          this.items = data;
          resolve(this.items);
        });
      }
      else {
        resolve(this.items);
      }
    });
  }

  LoadMealItems(meal_id: number) {
    return new Promise((resolve, reject) => {
      this.api.get(`meal/${meal_id}`).subscribe((data) => {
        const arr = data.json();

        let obj: any[] = [];

        for(var j = 0; j < arr.length; j++) {
          var item = arr[j];

          obj.push({
            _id: item.id,
            FoodId: item.food_id,
            Name: item.name,
            Brand: item.brand,
            Portion: item.portion,
            ServingSize: Number(item.serving_size),
            Serving: Number(item.serving),
            Nutrition: {
              Calories: Number(item.calories),
              Fat: Number(item.fat),
              Carbohydrates: Number(item.carbohydrates),
              Protein: Number(item.protein)
            }
          });
        }

        // sort food items for the meal
        obj = this.foodProvider.Sort(obj);

        resolve(obj);
      });
    });
  }

  LoadFoodItems(meal: MealModel) {
    return new Promise((resolve, reject) => {
      this.api.get(`meal/${meal._id}`).subscribe((data) => {
        const arr = data.json();

        let obj: any[] = [];

        for(var j = 0; j < arr.length; j++) {
          var item = arr[j];

          obj.push({
            _id: item.id,
            FoodId: item.food_id,
            Name: item.name,
            Brand: item.brand,
            Portion: item.portion,
            ServingSize: Number(item.serving_size),
            Serving: Number(item.serving),
            Nutrition: {
              Calories: Number(item.calories),
              Fat: Number(item.fat),
              Carbohydrates: Number(item.carbohydrates),
              Protein: Number(item.protein)
            }
          });
        }

        // sort food items for the meal
        obj = this.foodProvider.Sort(obj);

        meal.FoodItems = obj;

        // calc nutrition
        this.CalculateNutrition(meal);

        this.items.map(x => {
          if (x._id === meal._id) x = meal;
        });

        resolve(meal);
      });
    });
  }

  LoadMealItem(meal: MealModel, foodList: FoodModel[]) {
    meal.FoodItems.map((food: FoodModel, j) => {
      meal.FoodItems[j] = Object.assign(new FoodModel(), foodList.find(x => x._id === food._id));
      meal.FoodItems[j].Serving = food.Serving;
    });

    // calc and push
    this.CalculateNutrition(meal);
  }

  Remove(item: MealModel) {
    return new Promise((resolve, reject) => {
      this.api.delete(`meal/${item._id}`).subscribe((res) => {
        const data = res.json();
        if (data.success) {
          this.items = this.items.filter(m => m._id !== item._id);
          resolve(this.items);
        }
      });
    });
  }

  Save(item: MealModel) {
    return new Promise((resolve, reject) => {
      const isNew = item._id === undefined;

      // declare new meal
      let newItem: MealModel = {
        _id: item._id || null,
        Name: item.Name,
        FoodItems: [] as FoodModel[]
      };

      // each food item in meal
      item.FoodItems.map((elem: any, j) => {
        // add food items
        newItem.FoodItems.push({
          _id: elem._id || null,
          FoodId: elem.FoodId,
          Serving: elem.Serving,
        } as any);
      });

      this.api.post('meal/', newItem).subscribe((res) => {
        const data = res.json();
        if (data.success) {
          newItem._id = data.id;
          newItem.FoodCount = newItem.FoodItems.length;
          // clear food items to re-load in the page
          newItem.FoodItems = null;

          if (isNew) {
            // add the item to the list
            this.items.push(newItem);
          }
          else {
            // update food item count
            this.items.find(x => x._id === newItem._id).FoodCount = newItem.FoodCount;
          }

          resolve(newItem);
        }
      });
    });
  }

  Sort() {

    // sort meals
    this.items.sort((a: MealModel, b: MealModel) => {
      if (a.Name.toLowerCase() > b.Name.toLowerCase()) return 1;
      else if (a.Name.toLowerCase() < b.Name.toLowerCase()) return -1;
      else return 0;
    });

    return this.items;
  }

  private CalculateNutrition(meal: MealModel) {
    meal.Nutrition = new NutritionModel();
    meal.FoodItems.map((elem: FoodModel) => {
      meal.Nutrition.Calories += elem.Serving * elem.Nutrition.Calories;
      meal.Nutrition.Fat += elem.Serving * elem.Nutrition.Fat;
      meal.Nutrition.Carbohydrates += elem.Serving * elem.Nutrition.Carbohydrates;
      meal.Nutrition.Protein += elem.Serving * elem.Nutrition.Protein;
    });
  }

  private LoadFromApi() {
    return new Promise((resolve, reject) => {
      this.api.get('meal/').subscribe((data) => {

        const arr = data.json();

        let obj: MealModel[] = [];

        for(var j = 0; j < arr.length; j++) {
          var item = arr[j];

          obj.push({
            _id: item.id,
            Name: item.name,
            FoodCount: item.food_count
          });
        }

        resolve(obj);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/meal/meal.ts